/**
 * Vue I18n Plugin with Flat Key Support
 * Overrides Vue's $t function to support flat keys
 */
import type { App } from 'vue';
import { $tf } from './flattener';

export default {
	install (app: App) {
		// Override Vue's global $t function
		app.config.globalProperties.$t = (key: string, ...args: any[]) => {
			return $tf(key, ...args);
		};

		// Add debug helpers
		app.config.globalProperties.$getAvailableKeys = (namespace: string) => {
			const { getAvailableKeys } = require('./flattener');
			return getAvailableKeys(namespace);
		};
	},
};
